export const _convertObject = (filters) => {
    const overtime = {}
    const remaining_time = {}
    const newFilters = Object.assign({}, filters)

    Object.keys(newFilters).forEach(key => {
        if (newFilters[key] === null || newFilters[key] === undefined || newFilters[key] === '' || (Array.isArray(newFilters[key]) && newFilters[key].length === 0)) {
            delete newFilters[key]
        }

        if (!Array.isArray(newFilters[key]) && typeof newFilters[key] === 'object') {
            const objectChild = _convertObject(newFilters[key])

            delete newFilters[key]

            if (!!objectChild && Object.keys(objectChild).length === 0) {
                delete newFilters[key]
            } else {
                return Object.assign(newFilters, {[key]: objectChild})
            }
        }
    })

    const cloneFilter = Object.assign({}, newFilters)

    if (newFilters.hasOwnProperty('products.overtimeLte')) {
        Object.assign(overtime, {$lte: parseFloat(newFilters['products.overtimeLte'])})
        delete cloneFilter['products.overtimeLte']
    }

    if (newFilters.hasOwnProperty('products.overtimeGt')) {
        Object.assign(overtime, {$gt: parseFloat(newFilters['products.overtimeGt'])})
        delete cloneFilter['products.overtimeGt']
    }

    if (overtime.hasOwnProperty('$gt') || overtime.hasOwnProperty('$lte')) {
        Object.assign(cloneFilter, {'products.overtime': overtime})
    }

    if (newFilters.hasOwnProperty('products.remaining_time[from]')) {
        Object.assign(remaining_time, {from: parseFloat(newFilters['products.remaining_time[from]'])})
        delete cloneFilter['products.remaining_time[from]']
    }

    if (newFilters.hasOwnProperty('products.remaining_time[to]')) {
        Object.assign(remaining_time, {to: parseFloat(newFilters['products.remaining_time[to]'])})
        delete cloneFilter['products.remaining_time[to]']
    }

    if (remaining_time.hasOwnProperty('to') || remaining_time.hasOwnProperty('from')) {
        Object.assign(cloneFilter, {'products.remaining_time': remaining_time})
    }

    return cloneFilter
}

export default {
    _convertObject
}
